import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "icon-popup" }
const _hoisted_6 = { class: "icon-first" }
const _hoisted_7 = { class: "icon-last icon-last" }
const _hoisted_8 = { class: "form-inline" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]

import { ref } from "vue"
import { defineAsyncComponent } from 'vue';
import { icon_bar_status, select_icon, } from "@/composables/flagIcon"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexFontawesome',
  setup(__props) {

const iconsView = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/iconsView.vue"))
const CurrencyIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/CurrencyIcons.vue"))
const WebAppIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/WebAppIcons.vue"))
const SpinnerIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/SpinnerIcons.vue"))
const formControl = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/formControl.vue"))
const textEditor = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/textEditor.vue"))
const directionalIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/directionalIcons.vue"))
const videoPlayer = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/videoPlayer.vue"))
const brandIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/brandIcons.vue"))
const medicalIcons = defineAsyncComponent(() => import("@/components/theme/icons/font_awesome/medicalIcons.vue"))
function icon_bar(icon: string) {
    select_icon.value.class = 'fa fa-' + icon;
    select_icon.value.tag = '<i class="fa fa-' + icon + '"></i>';
    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info(' Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Icons",
      title: "Font Awesome Icon"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(iconsView), { onSelected: icon_bar }),
        _createVNode(_unref(CurrencyIcons), { onSelected: icon_bar }),
        _createVNode(_unref(WebAppIcons), { onSelected: icon_bar }),
        _createVNode(_unref(SpinnerIcons), { onSelected: icon_bar }),
        _createVNode(_unref(formControl), { onSelected: icon_bar }),
        _createVNode(_unref(textEditor), { onSelected: icon_bar }),
        _createVNode(_unref(directionalIcons), { onSelected: icon_bar }),
        _createVNode(_unref(videoPlayer), { onSelected: icon_bar }),
        _createVNode(_unref(brandIcons), { onSelected: icon_bar }),
        _createVNode(_unref(medicalIcons), { onSelected: icon_bar })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-hover-bottom p-fixed fa-fa-icon-show-div", { 'opecity-0': !_unref(icon_bar_status) }]),
      style: _normalizeStyle([_unref(icon_bar_status) ? { 'display': 'block' } : { 'display': 'none' }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "close-icon",
              onClick: close_icon_bar
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa-2x", [_unref(select_icon).class]])
              }, null, 2)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-class" }, [
              _createElementVNode("label", { class: "icon-title" }, "Class"),
              _createElementVNode("span", null, "icon-drupal")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "icon-title" }, "Markup", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    class: "inp-val form-control m-r-10",
                    type: "text",
                    ref: "text",
                    value: _unref(select_icon).tag
                  }, null, 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: copy_icon
                  }, "Copy text")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 6)
  ], 64))
}
}

})